export const aiEmployeePromoRoutes = {
    default:'ai_employee_promo',
    main: 'ai-employee-promo-main',
  }
  